/**
 * 회비내역 보고서 (/adm/fee-report) — 월·장비별 회원 회비(최근 3개월) + 합계, 엑셀
 * ($j.Pages.Admin.FeeReport / body data-page-name="FeeReport")  — 옛 public/js/a-fee-report.js
 */
export default class FeeReport {
    initialize() { initFeeReport(); }
}

let $table = null;

function initFeeReport() {
    initTable();
    initHandlers();
    // 회원번호 → 회원 포털, 회원명 → 그 회원 오더
    $('#table').on('click', 'a[data-fr]', function (e) {
        e.preventDefault();
        const n = Number(this.dataset.n);
        if (this.dataset.fr === 'portal') $j.F.Admin.Util.memberPortal(n);
        else $j.F.Admin.Util.userOrder(n);
    });
}

function initHandlers() {
    // 엔터로 폼이 전송되지 않게 (예전 onsubmit="return false")
    $('#searchForm').on('submit', (e) => e.preventDefault());
    $('#searchBtn').on('click', function () {
        $table.ajax.reload();
    });

    $('#yearmonth, #search_car').on('change', function () {
        $table.ajax.reload();
    });

    $('#excelBtn').on('click', function () {
        var ym = $('#yearmonth').val();
        var car = $('#search_car').val();
        if (!ym || !car) {
            alert('검색 조건을 선택하세요.');
            return;
        }
        location.href = '/excel/cash/fee?ym=' + ym + '&car=' + car;
    });
}

function initTable() {
    $table = new DataTable('#table', {
        columns: [
            {data: '_no', width: '50px', title: 'NO'},
            {
                data: 'mb_no', width: '80px', title: '회원번호',
                render: function (data) {
                    return "<a href='#' data-fr='portal' data-n='" + data + "'><b class='fr-link'>" + data + "</b></a>";
                }
            },
            {
                data: 'mem_name', width: '100px', title: '회원명',
                render: function (data, type, row) {
                    return "<a href='#' data-fr='order' data-n='" + row.mb_no + "'><b class='fr-link'>" + $j.Common.Util.nvl(data) + "</b></a>";
                }
            },
            {data: 'mem_car_type', width: '80px', title: '업종'},
            {data: '_group', width: '100px', title: '그룹'},
            {data: 'co_number', width: '130px', title: '사업자번호'},
            {data: 'co_title', title: '상호'},
            {data: 'co_ceoname', width: '100px', title: '대표자'},
            {
                data: 'p2', width: '100px', title: '-',
                className: 'text-right',
                render: function (data) { return $j.Common.Util.formatNumber(data); }
            },
            {
                data: 'p1', width: '100px', title: '-',
                className: 'text-right',
                render: function (data) { return $j.Common.Util.formatNumber(data); }
            },
            {
                data: 'p', width: '100px', title: '-',
                className: 'text-right',
                render: function (data) { return $j.Common.Util.formatNumber(data); }
            }
        ],
        ajax: {
            url: '/adm/ajax/fee-report',
            type: 'post',
            data: function (d) {
                d.yearmonth = $('#yearmonth').val();
                d.search_car = $('#search_car').val();
            },
            dataSrc: function (json) {
                if (json.totals && json.totals.ym) {
                    updateSummary(json.totals);
                    updateColumnHeaders(json.totals);
                }
                return json.data;
            }
        },
        processing: true,
        serverSide: true,
        ordering: false,
        displayLength: 50,
        lengthChange: false,
        searching: false,
        language: {
            emptyTable: '월을 선택하세요.',
            loadingRecords: '로딩 중...',
            zeroRecords: '데이터가 없습니다.',
            paginate: {
                previous: "<i class='fa fa-chevron-left'></i>",
                next: "<i class='fa fa-chevron-right'></i>"
            }
        }
    });
}

function updateSummary(totals) {
    $('#summary-area').show();
    $('#total-count').text($j.Common.Util.formatNumber(totals.count));
    $('#label-ym2').text(totals.ym2 + '월 합계');
    $('#total-ym2').text($j.Common.Util.formatNumber(totals.p2));
    $('#label-ym1').text(totals.ym1 + '월 합계');
    $('#total-ym1').text($j.Common.Util.formatNumber(totals.p1));
    $('#label-ym').text(totals.ym + '월 합계');
    $('#total-ym').text($j.Common.Util.formatNumber(totals.p));
}

function updateColumnHeaders(totals) {
    if (!$table) return;
    var header = $($table.table().header());
    var ths = header.find('th');
    $(ths[8]).text(totals.ym2);
    $(ths[9]).text(totals.ym1);
    $(ths[10]).text(totals.ym);
}
